import { TRANSACTION_TYPES } from "../../resources/enums";

export default function TransactionTypeBadge(
    { type, is_system_transaction = false }:
        { type: TRANSACTION_TYPES, is_system_transaction?: boolean }
) {
    return (
        <span
            className={`font-medium ${type === TRANSACTION_TYPES.CREDIT
                ? "text-green-600"
                : "text-red-500"
                } `}
        >
            {is_system_transaction ? "Commission Charge" : (type === TRANSACTION_TYPES.CREDIT ? "Deposit" : "Withdrawal")}
        </span>
    );
}